import { ADComplianceReport } from '@/features/end-of-lease/demo/ADComplianceReport';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/iata-binder/projects/$projectId/ad-report/',
)({
    component: ADComplianceReport,
});
